<template>

    <ContentWrapper>

        <SectionHeader :isCentered="true" subheader="Why Entegy?" title="What Makes Entegy the Right Choice" />

        <div class="md:grid md:grid-cols-3 gap-4 mt-18">
            <div class="rounded rounded-tl-4xl bg-gray-100 md:col-span-2 h-96 relative group"
                :style="{ backgroundImage: `url(${entegyImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }">

                <div class="absolute bottom-0 left-0 px-4 pb-4 pt-8 w-full bg-linear-to-b from-gray-900/0 to-gray-900 group-hover:py-12 group-hover:bg-gray-900 transition-all duration-300">
                    <div class="text-2xl font-headings text-white">Built by Event Professionals. Engineered for What's Next.                    </div>
                    <div class="text-gray-200 text-sm mt-2">Entegy is built on 25 years of real event industry experience, evolving alongside trends and technology. Our modern, ground-up codebase means no legacy compromises - just faster innovation and a clear roadmap shaped by the people who actually run events.</div>
                </div>
            </div>

            <div class="rounded bg-primary-500 p-4 h-96 text-white relative">
                <div class="absolute top-0 left-0 p-4 w-full">
                    
                    <div class="text-2xl font-headings text-white">Transparent Pricing. Zero Surprises.</div>
                    <div class="text-gray-200 text-sm mt-2">No hidden fees. No per-ticket charges. No paywalled features. Choose PAYG with no lock-in, or flexible subscription plans with serious savings - unlimited seats, BYO domains, and payment gateways all included.</div>
                </div>

                <img :src='megaphoneImage' alt="Megaphone" class="absolute bottom-10 left-1/2 -translate-x-1/2 w-32 h-32">
            </div>
        </div>

        <div class="md:grid md:grid-cols-3 gap-4 md:mt-4">
            <div class="rounded bg-accent-500 p-4 h-128 text-white overflow-hidden relative">
                <div class="absolute top-0 left-0 p-4 w-full">
                    <div class="text-2xl font-headings text-white">Powerful Permissions, Simplified</div>
                    <div class="text-gray-200 text-sm mt-2">One secure login for attendees, exhibitors, staff, speakers and admins. Role-based access ensures everyone sees exactly what they need - without juggling multiple systems or accounts.</div>
                </div>
                
                <div class="w-2/3 rounded-xl bg-white/20 h-full absolute left-1/2 -translate-x-1/2 top-40 p-2">
                    <img :src="permissionsImage" class="rounded-t-xl" alt="Permissions" >
                </div>
            </div>

            <div class="h-128">
                <div class="flex flex-col md:gap-4 h-full">
                    <div class="bg-gray-900 p-4 h-1/2">
                        
                        <div class="text-2xl font-headings text-white">Real Support, Your Way</div>
                        <div class="text-gray-200 text-sm mt-2">We focus on delivering powerful software - and back it with flexible support models to suit your team. Go fully managed, partner-supported, or DIY. However you run your events, we've got you covered.</div>
                        
                    </div>

                    <div class="bg-secondary-500 p-4 h-1/2">

                        <div class="text-2xl font-headings text-white">Built for Organisations, Not Just Events</div>
                        <div class="text-gray-200 text-sm mt-2">Manage all your events from one organisation-level account. Instantly activate new projects, use templates to move faster, and add unlimited users without added complexity.</div>

                    </div>
                </div>
            </div>

            <div class="rounded bg-gray-100 px-4 pb-4 pt-8 h-128 relative group"
                :style="{ backgroundImage: `url(${entegyImage2})`, backgroundSize: 'cover', backgroundPosition: 'center' }">
                <div class="absolute bottom-0 left-0 p-8 w-full bg-linear-to-b from-gray-900/0 to-gray-900 group-hover:py-12 group-hover:bg-gray-900 transition-all duration-300">
                    <div class="text-2xl font-headings text-white">Simple to Start. Powerful to Scale.</div>
                        <div class="text-gray-200 text-sm mt-2">From small meetings to large multi-day conferences, Entegy grows with you. Launch quickly with intuitive tools, then scale confidently as your events and organisation expand.</div>
                </div>
            </div>
        </div>

        <div class="md:grid md:grid-cols-3 gap-4 md:mt-4">
            <div class="rounded bg-gray-100 p-4 col-span-1 h-96">
                <div class="text-2xl font-headings text-white"></div>
                        
                        <div class="text-2xl font-headings text-primary-500">Beautiful. Consistent. On-Brand.</div>
                        <div class="text-gray-200 text-sm mt-2 text-gray-800">Deliver seamless, intuitive experiences across apps, web, portals and onsite tools - all perfectly aligned with your brand. Give your attendees technology you’re proud to put your name on.</div>
            </div>

            <div class="rounded rounded-br-4xl bg-secondary-500 p-4 col-span-2 h-96 relative">

                
                <div class="text-2xl font-headings text-white">A True Single Source of Truth</div>
                <div class="text-gray-200 text-sm mt-2">One platform. One database. No syncing. No silos. With profile-first registration and unified reporting, you capture the data that matters - because people attend events, not tickets.</div>
                <img :src='cowboyImage' alt="Megaphone" class="absolute bottom-0 right-0 w-64 h-64">
            </div>
        </div>

    </ContentWrapper>
</template>

<script setup>
import ContentWrapper from '../Layouts/ContentWrapper.vue'
import SectionHeader from '../Layouts/SectionHeader.vue'
import entegyImage from '../../images/photography/entegy04.png'
import entegyImage2 from '../../images/photography/entegy05.png'
import megaphoneImage from '../../images/megaphone.svg'
import cowboyImage from '../../images/illustration-cowboy.svg'

import permissionsImage from '@/images/screenshots/app/theme-1/my-profile.png'
</script>
